import { render, staticRenderFns } from "./ManagementProjectDialog.vue?vue&type=template&id=0b6578fc&scoped=true&"
import script from "./ManagementProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ManagementProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManagementProjectDialog.vue?vue&type=style&index=0&id=0b6578fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6578fc",
  null
  
)

export default component.exports